import { queryOptions } from '@tanstack/react-query';
import { GlobalPermissionType } from '@wavingroup/iot-core/gen/ts/wavin/kleos/v1/global_permission_pb';
import { authService } from '~/services/auth/auth-service';
import {
  listMyGlobalPermissions,
  PULSE_KLEOS_DOMAIN,
} from '~/services/api/fetchers/globalPermissions.api';
import { KleosQueryKey } from '~/services/queryKeys';
import { GlobalPermissionModel } from '~/shared/models/globalPermission/GlobalPermissionModel';
import { isAssignableKleosPermission } from '~/shared/models/role/kleosRoleMapping';

export function permissionsFromGrants(
  grants: { domain: number; permissions: GlobalPermissionType[] }[],
) {
  return grants
    .filter((grant) => grant.domain === PULSE_KLEOS_DOMAIN)
    .flatMap((grant) => grant.permissions)
    .filter(isAssignableKleosPermission)
    .map((permission) => new GlobalPermissionModel(permission));
}

export const myGlobalPermissionsQuery = () =>
  queryOptions({
    queryKey: [KleosQueryKey.LIST_MY_GLOBAL_PERMISSIONS],
    queryFn: async () => {
      const response = await listMyGlobalPermissions();
      return permissionsFromGrants(response.globalPermissions);
    },
    enabled: authService.isSignedIn,
  });
